import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FacturacionConIgvFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='facturacionConIgv'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-facturacionConIgv'
          label='Facturacion con IGV'
        />
      )}
    </Field>
  )
}

export default FacturacionConIgvFormGroup
